import { planSupportsBillingCycle } from "../../services/subscriptionCatalog";

export const isFreeTrialCatalogPlan = (plan) => (
    plan?.trial?.enabled === true && Number(plan?.monthlyPrice) === 0
);

/** @returns {{ ok: true, targetPlanId: string } | { ok: false, reason: string }} */
export function validateActivateTrialSelection({
    catalogPlanById,
    targetPlanId,
    accountTrialAvailable,
}) {
    const targetPlan = catalogPlanById.get(targetPlanId);
    if (!accountTrialAvailable) {
        return { ok: false, reason: "TRIAL_UNAVAILABLE" };
    }
    if (!targetPlan?.trial?.enabled || !isFreeTrialCatalogPlan(targetPlan)) {
        return { ok: false, reason: "INVALID_TRIAL_PLAN" };
    }
    return { ok: true, targetPlanId: targetPlan.id };
}

/** @returns {{ ok: true, targetPlanId: string, validity: string } | { ok: false, reason: string }} */
export function validatePaidCheckoutSelection({
    catalog,
    catalogPaidPlans,
    catalogPlanById,
    targetPlanId,
    validity,
}) {
    const normalizedPlanId = String(targetPlanId || "").trim();
    if (!normalizedPlanId || !catalogPaidPlans.includes(normalizedPlanId)) {
        return { ok: false, reason: "NO_PAID_PLAN" };
    }
    const targetPlan = catalogPlanById.get(normalizedPlanId);
    if (!targetPlan || !planSupportsBillingCycle(catalog, targetPlan, validity)) {
        return { ok: false, reason: "INVALID_BILLING_CYCLE" };
    }
    return { ok: true, targetPlanId: normalizedPlanId, validity };
}

export function buildActivateTrialActionPayload(targetPlanId) {
    return {
        actionKey: "activateTrial",
        actionName: "activateTrial",
        extraPayload: {
            subscription: {
                targetPlan: targetPlanId,
            },
        },
    };
}

export function buildPaidCheckoutActionPayload({
    actionKey,
    actionName,
    targetPlanId,
    validity,
}) {
    return {
        actionKey,
        actionName,
        extraPayload: {
            subscription: {
                targetPlan: targetPlanId,
                validity,
            },
        },
    };
}

export function buildDowngradeActionPayload(targetPlanId) {
    return {
        actionKey: "downgrade",
        actionName: "downgradePlan",
        extraPayload: {
            subscription: {
                targetPlan: targetPlanId,
            },
        },
    };
}

export function buildCancelActionPayload() {
    return {
        actionKey: "cancel",
        actionName: "cancelSubscription",
        extraPayload: {},
    };
}

export function resolveActivationDefaultPlanId({
    catalogPlans,
    catalogTrialPlans,
    catalogPaidPlans,
    accountTrialAvailable,
}) {
    if (accountTrialAvailable && catalogTrialPlans[0]?.id) {
        return catalogTrialPlans[0].id;
    }
    return catalogPaidPlans[0] || catalogPlans[0]?.id || "";
}
